import qs from "qs";

const getHashQuery = (name: any) => {
    let query = qs.parse(window.location.search.split("?")[1])
    let hash = qs.parse(window.location.hash.split("?")[1])
    let params = { ...query, ...hash }
    return name ? params[name] : query
}
export default getHashQuery